export const blogAppDefId = '14bcded7-0066-7c35-14d7-466cb3f09103';
export const oldBlogAppDefId = '79f391eb-7dfc-4adf-be6e-64434c4838d9';
export const membershipAppDefId = '1522827f-c56c-a5c9-2ac9-00f9e6ae12d3';
export const blogCommentsAppDefId = '774b5d26-ac71-4a20-b269-3c6512ac52e9';
export const blogCommentsWidgetId = '50efdf8b-04b4-4333-9bfb-b071348131e4';
export const categoryHeaderAppDefId = '7479d596-137c-4fa3-89cd-d7091042ba61';
